module.exports = __webpack_public_path__ + "static/img/gonglu1.12d163c4.png";